import React from 'react'

import { Check } from 'lucide-react'

import { useTranslation } from '@/core/i18n/useTranslation'
import { Button } from '@/shared/components/atoms/Button'
import {
	Dialog,
	DialogContent,
	DialogTitle,
} from '@/shared/components/molecules/Dialog/dialog'

interface ZoneCreatedSuccessModalProps {
	visible: boolean
	zoneId: number | null
	onClose: () => void
	onAssignToGroup: () => void
	onAddContent: () => void
}

const ZoneCreatedSuccessModal: React.FC<ZoneCreatedSuccessModalProps> = ({
	visible,
	zoneId: _zoneId,
	onClose,
	onAssignToGroup,
	onAddContent,
}) => {
	const { t } = useTranslation('common')

	return (
		<Dialog
			open={visible}
			onOpenChange={(open) => {
				if (!open) onClose()
			}}
		>
			<DialogContent
				className="sm:max-w-[600px] max-h-[90vh] p-0 gap-0 overflow-hidden flex flex-col"
				showCloseButton={true}
			>
				<div className="px-8 py-12 flex flex-col items-center text-center space-y-6">
					<div className="w-20 h-20 bg-muted rounded-2xl flex items-center justify-center">
						<div className="w-12 h-12 bg-white rounded-full flex items-center justify-center">
							<Check className="h-7 w-7 text-black" strokeWidth={3} />
						</div>
					</div>

					<DialogTitle className="text-3xl font-normal">
						{t('entities.zone.create.success.title')}
					</DialogTitle>

					<p className="text-base text-muted-foreground max-w-md">
						{t('entities.zone.create.success.description')}
					</p>

					<div className="flex items-center gap-3 pt-4">
						<Button
							type="button"
							variant="default"
							onClick={onAssignToGroup}
							className="rounded-full h-10 px-6 bg-[#101010] text-white border border-white/10 hover:bg-[#1a1a1a]"
						>
							{t('entities.zone.create.success.actions.assign_to_group')}
						</Button>
						<Button
							type="button"
							variant="default"
							onClick={onAddContent}
							className="rounded-full bg-white text-black hover:bg-gray-100 px-6 h-10"
						>
							{t('entities.zone.create.success.actions.add_content')}
						</Button>
					</div>
				</div>
			</DialogContent>
		</Dialog>
	)
}

export default ZoneCreatedSuccessModal
